import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/index.js';
import Title from '../../../components/Title/index.js';
import useAdminTools from '../../../Hooks/useAdminTools.js';
import ToolForm from './Form/index.js';

const CreateTool = () => {
  const { tool, setTool, handleAddTool, initState } = useAdminTools();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let isActive = true;

    if (isActive) {
      if (initState) {
        setTool(initState);
      }
    }

    return () => {
      isActive = false;
    };
  }, [initState, setTool]);

  const { title, description, requiredScore, type, items, relatedWorkbooks } = tool;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTool((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleItems = (item, callback) => {
    setTool((prev) => ({
      ...prev,
      items: [...prev.items, item]
    }));

    if (callback) {
      callback();
    }
  };

  const handleEditItem = (item, callback) => {
    setTool((prev) => {
      const updatedItems = prev.items.map((existingItem) => {
        // Using priority here
        if (existingItem.priority === item.priority) {
          return { ...existingItem, ...item };
        }
        return existingItem;
      });
      return { ...prev, items: updatedItems };
    });

    if (callback) {
      callback();
    }
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    const tempData = Array.from(items);
    const [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setTool((prev) => ({
      ...prev,
      items: tempData
    }));
  };

  return (
    <div className="w-full flex flex-col gap-8 p-8">
      <Title>Create Tool</Title>
      <div className="bg-white rounded-lg p-8 shadow-sm">
        <ToolForm
          title={title}
          description={description}
          requiredScore={requiredScore}
          type={type}
          items={items}
          relatedWorkbooks={relatedWorkbooks}
          handleChange={handleChange}
          handleItems={handleItems}
          handleEditItem={handleEditItem}
          handleDragEnd={handleDragEnd}
        />
      </div>
      <div className="flex gap-4 justify-end">
        <Button
          outline
          onClick={() => {
            setIsSubmitting(true);
            handleAddTool((newTool) => {
              setIsSubmitting(false);
              if (newTool) {
                navigate('/tools/v2');
              }
            });
          }}
          disabled={isSubmitting}
        >
          Save as Draft
        </Button>
        <Button
          onClick={() => {
            setIsSubmitting(true);
            setTool((prev) => ({ ...prev, status: 'publish' }));
            handleAddTool((newTool) => {
              setIsSubmitting(false);
              if (newTool) {
                navigate('/tools/v2');
              }
            });
          }}
          disabled={isSubmitting}
        >
          Publish
        </Button>
      </div>
    </div>
  );
};

export default CreateTool;

